<template>
  <div v-if="getLabels?.length > 0" class="def-labels">
    <div
      v-for="item in getLabels"
      :key="item.name"
      class="def-labels__item"
      :style="`background-color: ${item.color}; color: ${item?.fontColor}`"
    >
      <DefInformText v-if="item.text">
        <template #content>
          <DefContent v-html="item.text" />
        </template>
        <span>
          {{ item.name }}
        </span>
      </DefInformText>
      <span v-else>
        {{ item.name }}
      </span>
    </div>
  </div>
</template>

<script lang="ts" setup>
import { computed } from 'vue';
import DefInformText from '@components/Def/DefInformText/DefInformText.vue';
import DefContent from '@components/Def/DefContent/DefContent.vue';

const props = defineProps(['result']);

const getLabels = computed(() => props.result?.filter((item) => !item.picture));
</script>

<style lang="scss" scoped>
.def-labels {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 8px;
  &__item {
    display: block;
    padding: 4px 8px;
    font-size: 12px;
    font-weight: 600;
    line-height: 125%;
    text-transform: uppercase;
    white-space: nowrap;
  }
}
</style>
